/**
 * @file  Corporate
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useContext, useState, useEffect} from 'react';
import {message} from 'antd';
import {getByChannelCode, getInfoById} from '~/service/cms';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

const codeList = ['channel_ir_gsjj'];

function Corporate() {
    const [content, setContent] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    useEffect(() => {
        getByChannelCode({codeList})
            .then(({data}) => {
                const {channel_ir_gsjj: {contentResponseList}} = data;
                const {uid} = contentResponseList[0];
                getInfoById({uid})
                    .then(({data}) => {
                        const {content: {content, image: {url}}} = data;
                        setImageUrl(url);
                        setContent(content);
                    })
                    .catch(() => {
                        message.error('获取公司简介内容失败');
                    });
            })
            .catch(() => {
                message.error('获取公司信息失败');
            });
    }, []);


    return (
        <div className="corporate-content">
            <div
                className="corporate-img"
                style={{backgroundImage: `url(${imageUrl})`}}
            />
            {
                isMobile && (
                    <div className="orporate-content-title">
                        Corporate Profile
                    </div>
                )
            }
            <div
                className="corporate-text"
                dangerouslySetInnerHTML={{__html: content}}
            >
            </div>
        </div>
    );
}

export default Corporate;
